import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
setupInterceptorsTo(axios);

export type AzureNewsResponse =
{
    odataContext?: string;
    odataCount: number;
    value: AzureNewsType[];
    odataNextLink?: string;
}
export type AzureNewsType =
{
    searchScore: number;
    id: number,
    title: string,
    url: string,
    image?: string,
    publishDate: string,
    category?: string,
    summary?: string,
    newsImportId?: number
}
export type AzureDocFondosResponse =
{
    odataContext?: string;
    odataCount: number;
    value: AzureDocFondosType[];
    odataNextLink?: string;
}
export type AzureDocFondosType =
{
    searchScore: number;
    metadata_storage_name: string;
    metadata_storage_path: string;
    metadata_storage_file_extension: string;
    metadata_content_type: string;
    metadata_language: string;
    metadata_author: string;
    metadata_title: string;
    metadata_creation_date: string;
    isin?: string;
    name?: string;
}

class AzureSearchServices
{
    public searchNews = async (page: number, itemsPerPage: number, searchTerm: string): Promise<AzureNewsResponse> =>
    {
        let url: string = `${proxyUrl}/news/search?term=${encodeURIComponent(searchTerm)}&skip=${page * itemsPerPage}&limit=${itemsPerPage}`;
        const req = await axios.get(url);
        return req.data;
    }

    public searchDocsFunds = async (page: number, itemsPerPage: number, searchTerm: string): Promise<AzureDocFondosResponse> =>
    {
        let url: string = `${proxyUrl}/fundDocs/search?term=${encodeURIComponent(searchTerm)}&skip=${page * itemsPerPage}&limit=${itemsPerPage}`;
        const req = await axios.get(url);
        return req.data;
    }
}

const azureSearchServices = new AzureSearchServices();
export default azureSearchServices;